import React from "react";
import { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";


const Navbar = () => {
    //https://flowbite.com/docs/components/buttons/
    //http://localhost:3000/dashboard/observacion
    //https://www.hyperui.dev/components/application-ui/button-groups
  //   const messages = [
  //   { text: 'Hola, ¿cómo estás?', isOwnMessage: false },
  //   { text: 'Estoy bien, gracias. ¿Y tú?', isOwnMessage: true },
  //   // Agrega más mensajes aquí
  // ];

  const [messages, setMessages] = useState([]);
  const inputRef = useRef();
  const messagesEndRef = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    setMessages([...messages, inputRef.current.value]);
    inputRef.current.value = '';
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  return (
    <>
    <div className="fixed top-0 left-0 right-0 text-center z-10">
        <div className="rounded-lg border border-gray-100 bg-gray-100 p-1 inline-block">
        <button
        className="text-white bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-pink-300 dark:focus:ring-pink-800 shadow-lg shadow-pink-500/50 dark:shadow-lg dark:shadow-pink-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
       
      >
        Observaciones
      </button>

      <button
        className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 shadow-lg shadow-purple-500/50 dark:shadow-lg dark:shadow-purple-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
       
      >
        Mejoras Aplicación
      </button>

      <button
        className="text-white bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-teal-300 dark:focus:ring-teal-800 shadow-lg shadow-teal-500/50 dark:shadow-lg dark:shadow-teal-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
        
      >
        Otros
      </button>
        </div>
      </div>
    {/* <div className="fixed rounded-lg border border-gray-100 bg-gray-100 p-1 items-center">
      
    </div> */}
    <div className="p-4 h-screen flex flex-col justify-end mb-16">
        <div className="overflow-y-auto space-y-4">
          {messages.map((message, index) => (
            <div key={index} className="flex flex-col max-w-2xl mx-2 my-1 p-2 rounded-xl bg-blue-500 text-white ml-auto">
              <p>{message}</p>
              <span className="text-xs text-left text-gray-500 mt-1">
                Tú • 12:00 PM
              </span>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
      </div>
      <form
        onSubmit={handleSubmit}
        className="fixed bottom-0 left-0 right-0 flex items-center justify-center p-4 bg-white border-t"
      >
        <input
          ref={inputRef}
          type="text"
          className="w-full px-4 py-2 mr-4 border rounded-lg focus:outline-none focus:ring"
          placeholder="Type your message..."
        />
        <button
          type="submit"
          className="px-4 py-2 text-white bg-blue-500 rounded-lg focus:outline-none focus:ring"
        >
          Send
        </button>
      </form>
   
    </>
  );
};

// const ChatMessage = ({ message, isOwnMessage }) => {
//   const messageClass = isOwnMessage
//     ? 'bg-blue-500 text-white ml-auto'
//     : 'bg-gray-300 text-black mr-auto';

//   return (
//     <div className={`flex flex-col max-w-xs mx-2 my-1 p-2 rounded-xl ${messageClass}`}>
//       <p>{message}</p>
//       <span className="text-xs text-right text-gray-500 mt-1">
//         {isOwnMessage ? 'Tú' : 'Ellos'} • 12:00 PM
//       </span>
//     </div>
//   );
// };


export default Navbar;

{/* <>
    <div className=" rounded-lg border border-gray-100 bg-gray-100 p-1 text-center">
      <button
        className="text-white bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-pink-300 dark:focus:ring-pink-800 shadow-lg shadow-pink-500/50 dark:shadow-lg dark:shadow-pink-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
        onClick={() => alert('Edit button clicked')}
      >
        Observaciones
      </button>

      <button
        className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 shadow-lg shadow-purple-500/50 dark:shadow-lg dark:shadow-purple-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
        onClick={() => alert('View button clicked')}
      >
        Mejoras Aplicación
      </button>

      <button
        className="text-white bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-teal-300 dark:focus:ring-teal-800 shadow-lg shadow-teal-500/50 dark:shadow-lg dark:shadow-teal-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
        onClick={() => alert('Delete button clicked')}
      >
        Otros
      </button>
    </div>
    <div className="p-4 h-screen flex flex-col justify-end">
      <div className="overflow-y-auto space-y-4">
        {messages.map((message, index) => (
          <ChatMessage
            key={index}
            message={message.text}
            isOwnMessage={message.isOwnMessage}
          />
        ))}
      </div>
    </div>
    <form
      //onSubmit={handleSubmit}
      className="fixed bottom-0 left-0 right-0 flex items-center justify-center p-4 bg-white border-t"
    >
      <input
        type="text"
        //value={message}
        //onChange={(e) => setMessage(e.target.value)}
        className="w-full px-4 py-2 mr-4 border rounded-lg focus:outline-none focus:ring"
        placeholder="Type your message..."
      />
      <button
        type="submit"
        className="px-4 py-2 text-white bg-blue-500 rounded-lg focus:outline-none focus:ring"
      >
        Send
      </button>
    </form>
   
    </>
 */}
